export default {
  init() {
    // JavaScript to be fired on the home page

    $('.reviews-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      loop: true,
      adaptiveHeight: true,
      asNavFor: '.reviews-nav',
    })

    $('.reviews-nav').slick({
      slidesToShow: 7,
      slidesToScroll: 1,
      asNavFor: '.reviews-slider',
      dots: false,
      centerMode: true,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
          },
        },
      ],
    })

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/reviews.js